// deliberately import-free: `data/` reads this before the model barrel finishes initialising
export enum PatientInsuranceStatus {
  NotVerified = 'N',
  Active = 'A',
  Inactive = 'I',
}
